import Application from "../../Application";
import Area, { IArea } from "../../core/areas/Area";
import ShowPortalInteractor from "../interactors/ShowPortalInteractor";
import PortalHomePage from "../ui/pages/PortalHomePage";
import { IRouter } from "../../runtime/Router";
import { Layouts } from "../../core/common/Constants";
import ShowPortalCaseLawDocumentDetailsInteractor from "../interactors/caseLawDocument/ShowPortalCaseLawDocumentDetailsInteractor";
import GetCaseLawDocumentIndexesInteractor from "../interactors/caseLawDocument/GetCaseLawDocumentIndexesInteractor";
import FindCaseLawDocumentInteractor from "../interactors/caseLawDocument/FindCaseLawDocumentInteractor";
import GetAllCaseLawDocumentAttachmentsInteractor from "../interactors/caseLawDocument/GetAllCaseLawDocumentAttachmentsInteractor";
import GetAllCaseLawDocumentAttachmentTypesInteractor from "../interactors/caseLawDocument/GetAllCaseLawDocumentAttachmentTypesInteractor";
import GetCaseLawDocumentTypesInteractor from "../interactors/caseLawDocument/GetCaseLawDocumentTypesInteractor";
import GetInvalidatedCaseLawDocumentsInteractor from "../interactors/caseLawDocument/GetInvalidatedCaseLawDocumentsInteractor";
import GetInvalidatedCaseDecisionsInteractor from "../interactors/caseDecisions/GetInvalidatedCaseDecisionsInteractor";
import GetAllOrganisationsInteractor from "../interactors/GetAllOrganisationsInteractor";
import GetIndexTypeGroupTreeInteractor from "../interactors/GetIndexTypeGroupTreeInteractor";
import LoadApplicationInteractor from "../interactors/LoadApplicationInteractor";
import GetAllOrganisationIndexCategoriesInteractor from "../../organisations/interactors/GetAllOrganisationIndexCategoriesInteractor";
import GetHarmonizedIndexTreeInteractor from "../../organisations/interactors/GetHarmonizedIndexTreeInteractor";
import GetAllIndexTypeCategoriesInteractor from "../../indexTypes/interactors/GetAllIndexTypeCategoriesInteractor";
import AdvancedSearchCriteriaPage from "../../search/ui/pages/AdvancedSearchCriteriaPage";
import ShowAdvancedSearchCriteriaInteractor from "../../search/interactor/ShowAdvancedSearchCriteriaInteractor";
import PortalCaseDecisionDetailsPage from "../ui/pages/PortalCaseDecisionDetailsPage";
import LegalViewDetailsPage from "../../legalViews/ui/pages/LegalViewDetailsPage";
import ShowLegalViewDetailsInteractor from "../../legalViews/interactor/ShowLegalViewDetailsInteractor";
import ShowCaseDecisionDetailsInteractor from "../../caseDecisions/interactor/ShowCaseDecisionDetailsInteractor";
import FindCaseDecisionInteractor from "../../caseDecisions/interactor/FindCaseDecisionInteractor";
import GetAllCaseDecisionsInteractor from "../../caseDecisions/interactor/GetAllCaseDecisionsInteractor";
import GetAllCaseDecisionTypesInteractor from "../../caseDecisions/interactor/GetAllCaseDecisionTypesInteractor";
import GetAttachmentsForCaseDecisionInteractor from "../../caseDecisions/interactor/GetAttachmentsForCaseDecisionInteractor";
import GetCaseDecisionIndexesInteractor from "../../caseDecisions/interactor/GetCaseDecisionIndexesInteractor";
import GetCaseDecisionTypeIndexDataInteractor from "../../caseDecisions/interactor/GetCaseDecisionTypeIndexDataInteractor";
import ShowCaseDecisionsInteractor from "../../caseDecisions/interactor/ShowCaseDecisionsInteractor";
import ShowCaseDecisionTypesInteractor from "../../caseDecisions/interactor/ShowCaseDecisionTypesInteractor";
import FindCourtCaseDetailsForCaseDecisionInteractor from "../../caseLawDocuments/interactor/FindCourtCaseDetailsForCaseDecisionInteractor";
import GetAllGenericAttachmentTypesInteractor from "../../attachmentType/interactor/GetAllGenericAttachmentTypesInteractor";
import FindLegalViewInteractor from "../../legalViews/interactor/FindLegalViewInteractor";
import GetAllLegalViewsInteractor from "../../legalViews/interactor/GetAllLegalViewsInteractor";
import GetAllLegalViewTypesInteractor from "../../legalViews/interactor/GetAllLegalViewTypesInteractor";
import GetAttachmentsForLegalViewsInteractor from "../../legalViews/interactor/GetAttachmentsForLegalViewsInteractor";
import GetLegalViewIndexesInteractor from "../../legalViews/interactor/GetLegalViewIndexesInteractor";
import GetLegalViewTypeIndexDataInteractor from "../../legalViews/interactor/GetLegalViewTypeIndexDataInteractor";
import ShowLegalViewInteractor from "../../legalViews/interactor/ShowLegalViewInteractor";
import ShowLegalViewTypesInteractor from "../../legalViews/interactor/ShowLegalViewTypesInteractor";
import CaseLawDocumentDetailsPage from "../../caseLawDocuments/ui/pages/CaseLawDocumentDetailsPage";
import ShowCaseLawDocumentDetailsInteractor from "../../caseLawDocuments/interactor/ShowCaseLawDocumentDetailsInteractor";

export default class PortalArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor({
    application,
    router
  }: {
    application: Application;
    router: IRouter;
  }) {
    super();
    this.application = application;
    this.router = router;
  }

  private registerModules() {
    const container = this.application.container;
    container.registerInteractor("showPortal", ShowPortalInteractor);
    container.registerInteractor(
      "getCaseLawDocumentIndexes",
      GetCaseLawDocumentIndexesInteractor
    );
    container.registerInteractor(
      "findCaseLawDocument",
      FindCaseLawDocumentInteractor
    );
    container.registerInteractor(
      "getAllCaseLawDocumentAttachments",
      GetAllCaseLawDocumentAttachmentsInteractor
    );
    container.registerInteractor(
      "getAllCaseLawDocumentAttachmentTypes",
      GetAllCaseLawDocumentAttachmentTypesInteractor
    );
    container.registerInteractor(
      "getCaseLawDocumentTypes",
      GetCaseLawDocumentTypesInteractor
    );
    container.registerInteractor(
      "getInvalidatedCaseLawDocuments",
      GetInvalidatedCaseLawDocumentsInteractor
    );
    container.registerInteractor(
      "getInvalidatedCaseDecisions",
      GetInvalidatedCaseDecisionsInteractor
    );
    container.registerInteractor(
      "findCaseLawDocument",
      FindCaseLawDocumentInteractor
    );
    container.registerInteractor(
      "getAllOrganisations",
      GetAllOrganisationsInteractor
    );
    container.registerInteractor(
      "showPortalCaseLawDocumentDetails",
      ShowPortalCaseLawDocumentDetailsInteractor
    );

    container.registerInteractor(
      "findCaseDecision",
      FindCaseDecisionInteractor
    );
    container.registerInteractor(
      "getAllCaseDecisions",
      GetAllCaseDecisionsInteractor
    );
    container.registerInteractor(
      "showCaseDecisions",
      ShowCaseDecisionsInteractor
    );
    container.registerInteractor(
      "showCaseDecisionTypes",
      ShowCaseDecisionTypesInteractor
    );
    container.registerInteractor(
      "getAllCaseDecisionTypes",
      GetAllCaseDecisionTypesInteractor
    );
    container.registerInteractor(
      "getCaseDecisionTypeIndexData",
      GetCaseDecisionTypeIndexDataInteractor
    );
    container.registerInteractor(
      "getAttachmentsForCaseDecision",
      GetAttachmentsForCaseDecisionInteractor
    );
    container.registerInteractor(
      "showCaseDecisionDetails",
      ShowCaseDecisionDetailsInteractor
    );
    container.registerInteractor(
      "getCaseDecisionIndexes",
      GetCaseDecisionIndexesInteractor
    );

    container.registerInteractor(
      "findCourtCaseDetailsForCaseDecision",
      FindCourtCaseDetailsForCaseDecisionInteractor
    );

    container.registerInteractor(
      "getAllGenericAttachmentTypes",
      GetAllGenericAttachmentTypesInteractor
    );

    container.registerInteractor(
      "getIndexTypeGroupTree",
      GetIndexTypeGroupTreeInteractor
    );
    container.registerInteractor(
      "getAllOrganisationIndexCategories",
      GetAllOrganisationIndexCategoriesInteractor
    );
    container.registerInteractor(
      "getHarmonizedIndexTree",
      GetHarmonizedIndexTreeInteractor
    );
    container.registerInteractor(
      "getAllIndexTypeCategories",
      GetAllIndexTypeCategoriesInteractor
    );
    container.registerInteractor(
      "showCaseLawDocumentDetails",
      ShowCaseLawDocumentDetailsInteractor
    );

    container.registerInteractor("showLegalViews", ShowLegalViewInteractor);
    container.registerInteractor(
      "showLegalViewTypes",
      ShowLegalViewTypesInteractor
    );
    container.registerInteractor(
      "getAllLegalViewTypes",
      GetAllLegalViewTypesInteractor
    );

    container.registerInteractor(
      "getAllLegalViews",
      GetAllLegalViewsInteractor
    );
    container.registerInteractor(
      "getLegalViewTypeIndexData",
      GetLegalViewTypeIndexDataInteractor
    );

    container.registerInteractor(
      "showLegalViewDetails",
      ShowLegalViewDetailsInteractor
    );
    container.registerInteractor("findLegalView", FindLegalViewInteractor);
    container.registerInteractor(
      "getLegalViewIndexes",
      GetLegalViewIndexesInteractor
    );

    container.registerInteractor(
      "getAttachmentsForLegalViews",
      GetAttachmentsForLegalViewsInteractor
    );

    container.registerInteractor("loadApplication", LoadApplicationInteractor);
  }
  register(params: any) {
    this.registerModules();

    this.router.registerRoutes(
      {
        path: "/",
        page: this.createPage({
          Page: PortalHomePage,
          action: this.showPortalHomePage.bind(this)
        }),
        options: {
          secure: false,
          layout: Layouts.PORTAL
        }
      },
      {
        path: "/advanced-search",
        page: this.createPage({
          Page: AdvancedSearchCriteriaPage,
          action: this.showAdvancedSearchCriteriaPage.bind(this)
        })
      },
      {
        path: "/case-law-documents/:id/details",
        page: this.createPage({
          Page: CaseLawDocumentDetailsPage,
          action: this.showCaseLawDocumentDetailsPage.bind(this)
        }),
        options: {
          secure: false,
          layout: Layouts.PORTAL
        }
      },
      {
        path: "/case-decisions/:id/details",
        page: this.createPage({
          Page: PortalCaseDecisionDetailsPage,
          action: this.showCaseDecisionDetailsDetailsPage.bind(this)
        }),
        options: {
          secure: false,
          layout: Layouts.PORTAL
        }
      },
      {
        path: "/legal-views/:id/details",
        page: this.createPage({
          Page: LegalViewDetailsPage,
          action: this.showLegalViewDetailsDetailsPage.bind(this)
        }),
        options: {
          secure: false,
          layout: Layouts.PORTAL
        }
      }
    );
  }

  public showPortalHomePage() {
    return this.application.container
      .resolve<ShowPortalInteractor>("showPortal")
      .execute();
  }
  public showCaseLawDocumentDetailsPage({ id }: { id: string }) {
    return this.application.container
      .resolve<ShowCaseLawDocumentDetailsInteractor>(
        "showCaseLawDocumentDetails"
      )
      .execute(Number.parseInt(id, 10));
  }

  public showCaseDecisionDetailsDetailsPage({ id }: { id: string }) {
    return this.application.container
      .resolve<ShowCaseDecisionDetailsInteractor>("showCaseDecisionDetails")
      .execute(id);
  }
  public showLegalViewDetailsDetailsPage({ id }: { id: string }) {
    return this.application.container
      .resolve<ShowLegalViewDetailsInteractor>("showLegalViewDetails")
      .execute(Number.parseInt(id, 10));
  }

  public showAdvancedSearchCriteriaPage(params) {
    return this.application.container
      .resolve<ShowAdvancedSearchCriteriaInteractor>(
        "showAdvancedSearchCriteria"
      )
      .execute(params);
  }
}
